import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=cfbd0522&"
import script from "./partner.vue?vue&type=script&lang=ts&"
export * from "./partner.vue?vue&type=script&lang=ts&"
import style0 from "./partner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports